import * as $ from "jquery";

export default class HeadingAnimation {
  domRoot: JQuery<any>;
  params: any;
  animatedText: JQuery<HTMLElement>;
  replacementLength: any;
  fadeSpeed: number;
  typeSpeed: number;
  index: number;
  animation: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = $(domRoot);
    this.params = { ...params };
    this.animatedText = $(".animated-text", this.domRoot);
    this.replacementLength = this.params.animatedText.length;
    this.fadeSpeed = 200;
    this.typeSpeed = 100;
    this.index = 1;
    this.animation;
    this.init();
  }

  init() {
    this.animation = setInterval(
      function () {
        this.playAnimation();
      }.bind(this),
      this.params.duration
    );
  }

  playAnimation() {
    switch (this.params.style) {
      case "fadeIn":
        this.fadeInText();
        break;
      case "typewriter":
        this.typewriterText();
        break;
      default:
        break;
    }
  }

  handleLoop() {
    if (this.index === this.replacementLength - 1) {
      if (this.params.loop) {
        this.index = 0;
      } else {
        clearInterval(this.animation);
      }
    } else {
      this.index = this.index + 1;
    }
  }

  fadeInText() {
    this.animatedText.animate(
      { opacity: 0 },
      this.fadeSpeed,
      function () {
        this.animatedText
          .text(this.params.animatedText[this.index])
          .animate({ opacity: 1 }, this.fadeSpeed);
        this.handleLoop();
      }.bind(this)
    );
  }

  typewriterText() {
    var characters = this.params.animatedText[this.index].split("");
    var charactersLength = characters.length;
    var counter = 0;
    var text = "";
    var typing = setInterval(
      function () {
        text = text + characters[counter];
        this.animatedText.text(text);
        if (counter < charactersLength - 1) {
          counter = counter + 1;
        } else {
          clearInterval(typing);
        }
      }.bind(this),
      this.typeSpeed
    );
    this.handleLoop();
  }
}
